angular.module('natgeo').directive('credits', function()
{
  var controller = ['$scope', 'SoundEngine', 'UserProgress', 'ScreenView', '$element', 'container', 'screenManager',
  function Credits($scope, SoundEngine, UserProgress, ScreenView, element, container, screenManager)
  {
    // Build the elements!
    ScreenView.build( element );

    // Scale the elements!
    element.find('*').scale( container.getScale() );

    // Sequence the credit text into an array of animators.
    var $sequence = element.find('.credit-text')
      .sequence('span', '', '*')
    ;
    var sequence = $sequence
      .animators()
      .sequence( 15, 'linear', 'fadeIn', {duration: 300} )
    ;

    // When the element is ready, start playing the sequence.
    element.on('ready', function()
    {
      // Play the animation!
      $sequence.show();
      sequence.play();
    });

    // When the element is prepared, it applies the initial state.
    element.on('prepare', function()
    {
      $sequence.hide();
    });

  }];

  return {
    templateUrl: 'templates/credits.html',
    restrict: 'E',
    scope: {
      close: '&'
    },
    controller: controller
  };
})